export default __webpack_public_path__ + "static/media/a012-5.f7168bef.svg";